import { _t } from "./languageHandler";

// export function levelRoleMap(usersDefault: number): Record<number | "undefined", string> {
//     return {
//         undefined: _t("power_level.default"),
//         0: _t("power_level.restricted"),
//         [usersDefault]: _t("power_level.default"),
//         50: _t("power_level.moderator"),
//         100: _t("power_level.admin"),
//     };
// }

export function levelRoleMap(): Record<number | "undefined", string> {
    return {
        undefined: _t("power_level.default"),
        0: _t("power_level.user"),
        100: _t("power_level.admin"),
    };
}

// export function textualPowerLevel(level: number, usersDefault: number): string {
//     const LEVEL_ROLE_MAP = levelRoleMap();
//     if (LEVEL_ROLE_MAP[level]) {
//         return LEVEL_ROLE_MAP[level];
//     } else {
//         return _t("power_level.custom", { level });
//     }
// }

export function textualPowerLevel(level: number): string {
    const LEVEL_ROLE_MAP = levelRoleMap();
    if (LEVEL_ROLE_MAP[level]) {
        return LEVEL_ROLE_MAP[level];
    } else {
        return _t("power_level.custom", { level });
    }
}
